import { createIsomorphicFn } from '@tanstack/react-start'

export const reportError = createIsomorphicFn()
  .server((error: unknown) => {
    console.error(error)
  })
  .client((error: unknown) => {
    void import('./observability.client').then(({ pushClientError }) =>
      pushClientError(error),
    )
  })
